import { TaskDefinition } from '@shared/task/task-definition';

import { BaseModel } from '../../core/base/base-model';

export class TaskExecution extends BaseModel {
  startDate?: Date;
  endDate?: Date;
  description?: string;
  filename?: string;
  exitCode?: number;
  rowsOk?: number;
  rowsNotOk?: number;
  taskDefinition?: TaskDefinition;
}
